import { question_type_id } from "constants/customerQuestions.constants";

export const isMultiQuestionType = (type?: number) => {
  if (!type) return false;
  return [question_type_id.PAN, question_type_id.GST].includes(type);
};
